import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fmtFloatNum } from '../../../utils';

const selectCurrAltPrice = (
  activeUnit,
  {
    altUnit1,
    altPrice,
    altPrice1,
    altPromoPrice,
    altPromoPrice1,
    showPromoPrice,
  },
) => {
  let price = altPrice;
  let promoPrice = altPromoPrice;
  if (activeUnit === altUnit1) {
    price = altPrice1;
    promoPrice = altPromoPrice1;
  }

  return showPromoPrice ? promoPrice : price;
};

const selectPrevAltPrice = (
  activeUnit,
  { altPrice, altPrice1, altUnit1, showPromoPrice },
) => {
  let price = altPrice;
  if (activeUnit === altUnit1) {
    price = altPrice1;
  }

  return showPromoPrice ? price : null;
};

const PricePerUnit = ({ prod, renderPrice = true, valueCmpt: Value }) => {
  const { id, unit, price, promoPrice, showPromoPrice, isPromo } = prod;

  const { units: activeUnitByProd } = useSelector((state) => state.units);
  const activeUnit = activeUnitByProd[id] ? activeUnitByProd[id] : unit;

  const currPrice = showPromoPrice ? promoPrice : price;
  const prevPrice = showPromoPrice ? price : null;

  const [renderedPrice, setRenderedPrice] = useState(currPrice);
  const [renderedPrevPrice, setRenderedPrevPrice] = useState(prevPrice);

  useEffect(() => {
    const { unit, unitRate, unitRate1 } = prod;

    if (activeUnit === unit) {
      setRenderedPrice(currPrice);
      setRenderedPrevPrice(prevPrice);
      return;
    }

    if (Number(unitRate) === 0 && Number(unitRate1) === 0) {
      return;
    }

    const currAltPrice = selectCurrAltPrice(activeUnit, prod);
    const prevAltPrice = selectPrevAltPrice(activeUnit, prod);

    setRenderedPrice(currAltPrice);
    setRenderedPrevPrice(prevAltPrice);
  }, [activeUnit, prod]);

  return (
    <Value
      price={fmtFloatNum(renderedPrice)}
      prevPrice={fmtFloatNum(renderedPrevPrice)}
      unit={activeUnit}
      renderPrice={renderPrice}
      isPromo={isPromo}
    />
  );
};

export default PricePerUnit;
